import HomePageBuilder from './../Builders/HomePageBuilder';
import AboutUsPageBuilder from './../Builders/AboutUsPageBuilder';
import BrandsInWorkWithUsePageBuilder from './../Builders/BrandsInWorkWithUsePageBuilder';
import WorkWithUsPageBuilder from './../Builders/WorkWithUsPageBuilder';
import ContactUsPageBuilder from './../Builders/ContactUsPageBuilder';
import JobConditionsPageBuilder from './../Builders/JobConditionsPageBuilder';
import FaqsPageBuilder from './../Builders/FaqsPageBuilder';
import PolicyPageBuilder from './../Builders/PolicyPageBuilder';
import AppPageBuilder from './../Builders/AppPageBuilder';
import InviteFriendsPageBuilder from './../Builders/InviteFriendsPageBuilder';
import FooterPageBuilder from './../Builders/FooterPageBuilder';
import LaravelJobConditionPageBuilder from './../Builders/LaravelJobConditionPageBuilder';
import SchemaPageBuilder from '../Builders/SchemaPageBuilder';


const forms = {
    home: HomePageBuilder,
    brands: HomePageBuilder,
    "coupons-popularity": HomePageBuilder,
    "coupons-publish_date": HomePageBuilder,
    "coupons-views": HomePageBuilder,
    events: HomePageBuilder,
    "about-us": AboutUsPageBuilder,
    "contact-us": ContactUsPageBuilder,
    "brands-in-work-with-us": BrandsInWorkWithUsePageBuilder,
    "work-with-us": WorkWithUsPageBuilder,
    "job-conditions": JobConditionsPageBuilder,
    "faqs": FaqsPageBuilder,
    "policy": PolicyPageBuilder,
    "app": AppPageBuilder,
    "invite-friends": InviteFriendsPageBuilder,
    "footer": FooterPageBuilder,
    "laravel-job-condition": LaravelJobConditionPageBuilder,
    "sitemap-coupons": SchemaPageBuilder,
    "sitemap-brands": SchemaPageBuilder,
    "sitemap-events": SchemaPageBuilder,
    "sitemap-events-main": SchemaPageBuilder,
    "sitemap-luckywheels": SchemaPageBuilder,
    "sitemap-luckywheels-main": SchemaPageBuilder,
    "sitemap-categories": SchemaPageBuilder,
    "sitemap-landings": SchemaPageBuilder,
    "sitemap-wall": SchemaPageBuilder,
    "sitemap-home": SchemaPageBuilder,
    "sitemap-coupons-newest": SchemaPageBuilder,
    "sitemap-coupons-popular": SchemaPageBuilder,
    "sitemap-coupons-views": SchemaPageBuilder,
    "all-products" : HomePageBuilder,
};

export default forms;


// WEBPACK FOOTER //
// ./src/containers/Pages/Forms/index.js